export const validateRedirect = (redirectUrl: string, baseUrl: string) => {
    if (!redirectUrl) {
        return false;
    }
    const absolutePath = /^\/[a-zA-Z]+/.test(redirectUrl);
    if (absolutePath) {
        return true;
    }
    let hostMatch = false;
    try {
        const base = new URL(baseUrl);
        const url = new URL(redirectUrl);
        hostMatch = url.host === base.host;
    } catch (_) {
        return false;
    }
    return hostMatch;
};
